import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import React from "react";

export interface IInputDialogResult {
  date: string|null,
  text: string|null
};

export interface GlobalInputDialogState {
  show: boolean,
  resolve: ((value: IInputDialogResult | PromiseLike<IInputDialogResult>) => void) | null,
  content: React.ReactNode | null,
};

export interface GlobalInputDialogData {
  resolve: ((value: IInputDialogResult | PromiseLike<IInputDialogResult>) => void) | null,
  content: React.ReactNode | null,
};

const initialState:GlobalInputDialogState = {
  show: false,
  resolve: null,
  content: null,
};

const globalInputDialogSlice = createSlice({
  name: 'globalInputDialogSlice',
  initialState,
  reducers: {
    showGlobalInputDialog: (state, action: PayloadAction<GlobalInputDialogData>) => {
      state.show = true;
      state.resolve = action.payload.resolve;
      state.content = action.payload.content;
    },
    hideGlobalInputDialog: (state) => {
      state.show = false;
      state.resolve = null;
      state.content = null;
    }
  }
});

export default globalInputDialogSlice.reducer;

export const { showGlobalInputDialog, hideGlobalInputDialog } = globalInputDialogSlice.actions;